// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';

const requiredPart = t.interface({
  accordionId: PositiveIntegerSchema,
  position: PositiveIntegerSchema,
});

export const CriteriaIndexSchema = excess(requiredPart);

export interface CriteriaIndex extends t.TypeOf<typeof CriteriaIndexSchema> {}
